import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { meterDetailHeaders } from './constants'
import type { MeterWithReadings } from './types'
import { formatDate } from '../utils'
import {
	meterTypeMessage,
	readingMethodMessage,
} from 'ui/ManagerFinance/utils/messages'
import type { ApartmentSelectOptions } from '@viilu-web/shared/types/apartment'

const Table = styled.table`
	border-collapse: collapse;
	border: 1px solid rgba(0, 0, 0, 0.2);

	td {
		padding: 4px 8px;
		white-space: nowrap;
		border-bottom: 1px solid rgba(0, 0, 0, 0.2);
	}

	td:nth-child(2) {
		text-align: right;
	}
`

type Props = {
	meter: MeterWithReadings | undefined
	apartmentOptions: ApartmentSelectOptions[]
}

function MeterDetailsTable({ meter, apartmentOptions }: Props) {
	const intl = useIntl()

	if (!meter) {
		return null
	}

	const getValue = (key: string, type?: string) => {
		let value = meter[key]

		switch (type) {
			case 'date':
				return formatDate(value)
			case 'meterType':
				return meterTypeMessage(intl, value)
			case 'readingMethod':
				return readingMethodMessage(intl, value)
			case 'apartmentOptions':
				return (
					apartmentOptions.find((a) => a.value === value)?.label ||
					meter.apartmentIdentifier ||
					'-'
				)
			default:
				return value || ''
		}
	}

	return (
		<Table>
			<tbody>
				{meterDetailHeaders.map((header) => {
					const { key, title, type } = header
					return (
						<tr key={key}>
							<td>{title(intl)}</td>
							<td>{getValue(key, type) || '-'}</td>
						</tr>
					)
				})}
			</tbody>
		</Table>
	)
}

export default MeterDetailsTable
